import styled, { css } from 'styled-components';
import { Subtitle, Body } from 'components/Typography';
import DefaultAvatar from 'components/Avatar';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';
import DefaultIntegrationStatus from '../IntegrationStatus';

import { StatusProps } from './types';

const ROW_HEIGHT = '4.5rem';

export const Card = styled.div`
  width: 30rem;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 1.5rem;
  :not(:first-child) {
    margin-top: 1.5rem;
  }
`;

// TODO: TFR-44 move to containers group
// TODO: TFR-44 move to container group
export const Row = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 2rem;
`;

// TODO: TFR-45:Header make unique name or do not export
export const Header = styled(Row)`
  :hover {
    cursor: pointer;
  }
`;

// TODO: TFR-44 move to containers group
export const Content = styled.div`
  border-top: 0.0625rem solid ${({ theme }) => theme.colors.gray2};
`;

// TODO: TFR-44 move to containers group. Just exact as in IntegrationStatus
export const RightSection = styled.div`
  padding-right: 2rem;
  width: 100%;
  height: ${ROW_HEIGHT};
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const RightSectionBorder = styled(RightSection)`
  border-top: 0.0625rem solid ${({ theme }) => theme.colors.gray2};
`;

// TODO: TFR-45:Avatar make unique name or do not export
export const Avatar = styled(DefaultAvatar)`
  width: 2rem;
  height: 2rem;
  margin-right: 1rem;
`;

// TODO: TFR-46 remove imports in styled.ts if you do not add styles to component
export const BrandName = styled(Subtitle)``;

// TODO: TFR-44 move to icons group
export const ArrowDown = styled(FiChevronDown)`
  width: 1.5rem;
  height: 1.5rem;
`;

// TODO: TFR-44 move to icons group
export const ArrowUp = styled(FiChevronUp)`
  width: 1.5rem;
  height: 1.5rem;
`;

// TODO: TFR-44 move to typography group
export const Hour = styled(Body)`
  color: ${({ theme }) => theme.colors.navyGreen};
  opacity: 0.8;
  font-size: 1.0625rem;
`;

export const FloatRight = styled.div`
  display: flex;
`;

export const StatusLabel = styled.span<StatusProps>`
  display: flex;
  align-items: center;
  margin-right: 1rem;
  background-color: ${(props) =>
    props.online
      ? props.theme.colors.positiveLight
      : props.theme.colors.passiveLight};
  color: ${(props) =>
    props.online
      ? props.theme.colors.positiveText
      : props.theme.colors.passiveText};
  opacity: 0.8;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;

  ${({ online }) => {
    switch (online) {
      case true:
        return css`
          ::after {
            content: 'Online';
          }
        `;
      case false:
      default:
        return css`
          ::after {
            content: 'Offline';
          }
        `;
    }
  }}
`;

// TODO: TFR-44 looks similar to component/Status could be united and reused
export const ColoredDot = styled.span<StatusProps>`
  ${({ online }) => {
    if (online) {
      return css`
        background-color: ${(props) => props.theme.colors.freshGreenLight};
      `;
    }
    return css`
      border-color: ${(props) => props.theme.colors.gray};
      border: solid;
      border-width: 0.1rem;
    `;
  }}
  border-radius: 50%;
  width: 0.5rem;
  height: 0.5rem;
  margin-right: 0.25rem;
`;

// TODO: TFR-46 remove imports in styled.ts if you do not add styles to component
export const IntegrationStatus = styled(DefaultIntegrationStatus)``;
